var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    {
      staticClass: "c-pagination-wrapper",
      attrs: { "aria-label": "Page navigation" },
    },
    [
      _c(
        "ul",
        { staticClass: "pagination justify-content-center m-0" },
        [
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: _setup.currentPage == 1 },
              attrs: { "aria-label": "first page" },
              on: {
                click: function ($event) {
                  return _setup.goToPage(1)
                },
              },
            },
            [_vm._m(0)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: _setup.currentPage == 1 },
              attrs: { "aria-label": "previous" },
              on: {
                click: function ($event) {
                  return _setup.goToPage(_setup.currentPage - 1)
                },
              },
            },
            [_vm._m(1)]
          ),
          _vm._v(" "),
          _vm._l(_setup.displayedPages, function (page) {
            return _c(
              "li",
              {
                key: `page-${page}`,
                staticClass: "page-item",
                class: { active: page == _setup.currentPage },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "page-link",
                    attrs: { role: "button" },
                    on: {
                      click: function ($event) {
                        return _setup.goToPage(page)
                      },
                    },
                  },
                  [_vm._v(_vm._s(page))]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: _setup.currentPage == _setup.totalPages },
              on: {
                click: function ($event) {
                  return _setup.goToPage(_setup.currentPage + 1)
                },
              },
            },
            [_vm._m(2)]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: _setup.currentPage == _setup.totalPages },
              on: {
                click: function ($event) {
                  return _setup.goToPage(_setup.totalPages)
                },
              },
            },
            [_vm._m(3)]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "page-link", attrs: { role: "button" } }, [
      _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("«")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "page-link", attrs: { role: "button" } }, [
      _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("‹")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "span",
      { staticClass: "page-link", attrs: { "aria-label": "next" } },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(" › ")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "span",
      {
        staticClass: "page-link",
        attrs: { role: "button", "aria-label": "last page" },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("»")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }